/**
 * The 107 Italian provinces and metropolitan cities, by their two-letter postal code (the
 * `sigla` written on addresses and car plates). Used by the `indirizzi` select.
 */
export const province = [
  { sigla: 'AG', nome: 'Agrigento' },
  { sigla: 'AL', nome: 'Alessandria' },
  { sigla: 'AN', nome: 'Ancona' },
  { sigla: 'AO', nome: 'Aosta' },
  { sigla: 'AP', nome: 'Ascoli Piceno' },
  { sigla: 'AQ', nome: 'L’Aquila' },
  { sigla: 'AR', nome: 'Arezzo' },
  { sigla: 'AT', nome: 'Asti' },
  { sigla: 'AV', nome: 'Avellino' },
  { sigla: 'BA', nome: 'Bari' },
  { sigla: 'BG', nome: 'Bergamo' },
  { sigla: 'BI', nome: 'Biella' },
  { sigla: 'BL', nome: 'Belluno' },
  { sigla: 'BN', nome: 'Benevento' },
  { sigla: 'BO', nome: 'Bologna' },
  { sigla: 'BR', nome: 'Brindisi' },
  { sigla: 'BS', nome: 'Brescia' },
  { sigla: 'BT', nome: 'Barletta-Andria-Trani' },
  { sigla: 'BZ', nome: 'Bolzano' },
  { sigla: 'CA', nome: 'Cagliari' },
  { sigla: 'CB', nome: 'Campobasso' },
  { sigla: 'CE', nome: 'Caserta' },
  { sigla: 'CH', nome: 'Chieti' },
  { sigla: 'CL', nome: 'Caltanissetta' },
  { sigla: 'CN', nome: 'Cuneo' },
  { sigla: 'CO', nome: 'Como' },
  { sigla: 'CR', nome: 'Cremona' },
  { sigla: 'CS', nome: 'Cosenza' },
  { sigla: 'CT', nome: 'Catania' },
  { sigla: 'CZ', nome: 'Catanzaro' },
  { sigla: 'EN', nome: 'Enna' },
  { sigla: 'FC', nome: 'Forlì-Cesena' },
  { sigla: 'FE', nome: 'Ferrara' },
  { sigla: 'FG', nome: 'Foggia' },
  { sigla: 'FI', nome: 'Firenze' },
  { sigla: 'FM', nome: 'Fermo' },
  { sigla: 'FR', nome: 'Frosinone' },
  { sigla: 'GE', nome: 'Genova' },
  { sigla: 'GO', nome: 'Gorizia' },
  { sigla: 'GR', nome: 'Grosseto' },
  { sigla: 'IM', nome: 'Imperia' },
  { sigla: 'IS', nome: 'Isernia' },
  { sigla: 'KR', nome: 'Crotone' },
  { sigla: 'LC', nome: 'Lecco' },
  { sigla: 'LE', nome: 'Lecce' },
  { sigla: 'LI', nome: 'Livorno' },
  { sigla: 'LO', nome: 'Lodi' },
  { sigla: 'LT', nome: 'Latina' },
  { sigla: 'LU', nome: 'Lucca' },
  { sigla: 'MB', nome: 'Monza e della Brianza' },
  { sigla: 'MC', nome: 'Macerata' },
  { sigla: 'ME', nome: 'Messina' },
  { sigla: 'MI', nome: 'Milano' },
  { sigla: 'MN', nome: 'Mantova' },
  { sigla: 'MO', nome: 'Modena' },
  { sigla: 'MS', nome: 'Massa-Carrara' },
  { sigla: 'MT', nome: 'Matera' },
  { sigla: 'NA', nome: 'Napoli' },
  { sigla: 'NO', nome: 'Novara' },
  { sigla: 'NU', nome: 'Nuoro' },
  { sigla: 'OR', nome: 'Oristano' },
  { sigla: 'PA', nome: 'Palermo' },
  { sigla: 'PC', nome: 'Piacenza' },
  { sigla: 'PD', nome: 'Padova' },
  { sigla: 'PE', nome: 'Pescara' },
  { sigla: 'PG', nome: 'Perugia' },
  { sigla: 'PI', nome: 'Pisa' },
  { sigla: 'PN', nome: 'Pordenone' },
  { sigla: 'PO', nome: 'Prato' },
  { sigla: 'PR', nome: 'Parma' },
  { sigla: 'PT', nome: 'Pistoia' },
  { sigla: 'PU', nome: 'Pesaro e Urbino' },
  { sigla: 'PV', nome: 'Pavia' },
  { sigla: 'PZ', nome: 'Potenza' },
  { sigla: 'RA', nome: 'Ravenna' },
  { sigla: 'RC', nome: 'Reggio Calabria' },
  { sigla: 'RE', nome: 'Reggio Emilia' },
  { sigla: 'RG', nome: 'Ragusa' },
  { sigla: 'RI', nome: 'Rieti' },
  { sigla: 'RM', nome: 'Roma' },
  { sigla: 'RN', nome: 'Rimini' },
  { sigla: 'RO', nome: 'Rovigo' },
  { sigla: 'SA', nome: 'Salerno' },
  { sigla: 'SI', nome: 'Siena' },
  { sigla: 'SO', nome: 'Sondrio' },
  { sigla: 'SP', nome: 'La Spezia' },
  { sigla: 'SR', nome: 'Siracusa' },
  { sigla: 'SS', nome: 'Sassari' },
  { sigla: 'SU', nome: 'Sud Sardegna' },
  { sigla: 'SV', nome: 'Savona' },
  { sigla: 'TA', nome: 'Taranto' },
  { sigla: 'TE', nome: 'Teramo' },
  { sigla: 'TN', nome: 'Trento' },
  { sigla: 'TO', nome: 'Torino' },
  { sigla: 'TP', nome: 'Trapani' },
  { sigla: 'TR', nome: 'Terni' },
  { sigla: 'TS', nome: 'Trieste' },
  { sigla: 'TV', nome: 'Treviso' },
  { sigla: 'UD', nome: 'Udine' },
  { sigla: 'VA', nome: 'Varese' },
  { sigla: 'VB', nome: 'Verbano-Cusio-Ossola' },
  { sigla: 'VC', nome: 'Vercelli' },
  { sigla: 'VE', nome: 'Venezia' },
  { sigla: 'VI', nome: 'Vicenza' },
  { sigla: 'VR', nome: 'Verona' },
  { sigla: 'VT', nome: 'Viterbo' },
  { sigla: 'VV', nome: 'Vibo Valentia' },
] as const

export type SiglaProvincia = (typeof province)[number]['sigla']

const sigle: ReadonlySet<string> = new Set(province.map((p) => p.sigla))

export const provinciaValida = (valore: string): valore is SiglaProvincia => sigle.has(valore)

/** Italian postal code: exactly five digits. */
export const capValido = (valore: string) => /^\d{5}$/.test(valore)

/**
 * Countries an address may be in. Italy only for now: shipping abroad is still an open
 * question. Adding a country here (and to the select) is all it takes on the data side.
 */
export const nazioni = [{ codice: 'IT', nome: 'Italia' }] as const
